import { useEffect, useState } from 'react';

const useIsOnline = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	// Attach events (but wait for window load)
	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		const handleLoad = () => {
			window.addEventListener('online', handleOnline);
			window.addEventListener('offline', handleOffline);
		};

		if (document.readyState === 'complete') {
			handleLoad();
		} else {
			window.addEventListener('load', handleLoad);
		}

		return () => {
			window.removeEventListener('load', handleLoad);
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	// For in-app WebViews, events don't always work, so also check every 10 seconds
	useEffect(() => {
		const interval = setInterval(() => {
			if (isOnline !== navigator.onLine) setIsOnline(navigator.onLine);
		}, 10000);

		return () => clearInterval(interval);
	}, [isOnline]);

	return isOnline;
};

export default useIsOnline;
